import React from 'react'
import PropTypes from 'prop-types'
import { throwError } from 'cerebral'
import { DEPRECATE } from 'cerebral/internal'

class Container extends React.Component {
  getChildContext() {
    const { app, controller } = this.props

    if (controller) {
      DEPRECATE(
        'Container',
        'please change from "controller" to "app" property'
      )
    }

    if (!app && !controller) {
      throwError('You are not passing a Cerebral app to Container')
    }

    return { controller: app || controller }
  }

  render() {
    return this.props.children
  }
}

Container.propTypes = {
  app: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}
Container.childContextTypes = {
  controller: PropTypes.object.isRequired,
}

export default Container
